export const router = [
  {
    path: "download",
    component: (resolve) => require(["./layout/Index.vue"], resolve),
    children: [
    ],
  },
];
